const electronProtocol = 'kartoy:'
const electronUserAgentToken = 'KartoyElectron'

export function isElectron(): boolean {
  if (typeof window === 'undefined') return false

  return window.location.protocol === electronProtocol || navigator.userAgent.includes(electronUserAgentToken)
}

// Маркер для Electron-only CSS (размер окна / выравнивание shell)
export function installElectronDocumentAttributes(): void {
  if (!isElectron()) return

  document.documentElement.dataset.electron = ''
}
